import { ApplicationRootState } from 'types';
import { Product } from 'types/schema';
import { ActionType } from 'typesafe-actions';
import { ContactUsPageState } from '../../ContactUsPage/types';
import * as actions from './actions';

export interface ISection {
  [k: string]: ISectionData;
}

export interface KamereoEssentialPageState {
  readonly loading: boolean;
  readonly sections: ISection;
  readonly loadingNote: boolean;
}

type KamereoEssentialPageActions = ActionType<typeof actions>;

export const CommonDimensions = {
  MAX_WIDTH_CONTAINER: 1272,
};

export enum KamereoEssentialSectionEnum {
  EcoProduct = 'KAMEREO_ECO_PRODUCTS',
  CleaningsProducts = 'KAMEREO_CLEANINGS_PRODUCTS',
  ConvenienceSupplies = 'KAMEREO_CONVENIENCE_SUPPLIES',
}

export interface ISectionData {
  id: KamereoEssentialSectionEnum;
  title: string;
  categoryIds: number[];
  banner: string;
  data: Product[];
  error: boolean;
  fetching?: boolean;
  totalResults: number;
  loading?: boolean;
}

export interface KamereoEssentialScreenState {
  readonly sections: ISection;
}

export type RootState = ApplicationRootState;
export type ContainerState = KamereoEssentialPageState & Partial<ContactUsPageState>;
export type ContainerActions = KamereoEssentialPageActions;
